import script from "./AntagonistForm.vue?vue&type=script&setup=true&lang=js"
export * from "./AntagonistForm.vue?vue&type=script&setup=true&lang=js"

import "./AntagonistForm.vue?vue&type=style&index=0&id=e332034c&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e332034c"]])

export default __exports__